export const modalTheme = {
  baseStyle: {
    closeButton: {
      color: 'primaryColor',
    },
  },
};
